
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiCursorClosedHand as ObiCursorClosedHandElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-cursor-closed-hand.js';
 
 
 

 
 export const ObiCursorClosedHand = createComponent({
   react: React,
   tagName: 'obi-cursor-closed-hand',
   elementClass: ObiCursorClosedHandElement,
   events: {
     
   }
  });
 
 